<template>
  <section class="create-merchant">
    <div class="coming-soon">
      <img
        src="~@/assets/img/smiling.svg"
        alt="Coming Soon">
      <h3>Coming Soon</h3>
    </div>
  </section>
</template>

<script>
import '@/assets/css/modules/_create-merchant.scss';

export default {
  name: 'ComingSoon',
};
</script>
